import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import {
  columnCreatedOn,
  columnDescription,
  columnMultiSelect,
  columnNameLink,
  columnTools,
  columnUpdatedOn,
  columnVisibility,
} from '@/constants/fields';
import urls, { codeUrl } from '@/constants/urls';
import { presentationOptions } from '@/constants/states';
import { states } from '@/constants/lifecycle';
import { fitToPage, goToCategoryPage } from '@/hooks/paging';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import ToggleCardsButton from '@/components/cards/ToggleCardsButton';
import CohortsTableRows from './CohortsTableRows';
import CohortsTableHeader from './CohortsTableHeader';
import CohortsFilters from '../containers/CohortsFilters';

const CohortsTable = ({
  canCreate,
  category,
  className,
  cohorts,
  columns = [
    columnMultiSelect,
    columnNameLink,
    columnDescription,
    columnCreatedOn,
    columnUpdatedOn,
    columnVisibility,
    columnTools,
  ],
  currentPage,
  fetchData,
  hideColumns,
  newCohortCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  togglePresentation,
  total,
}) => {
  const { items, pageNumber } = fitToPage(cohorts, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <div className={clsx('ReactTable', className)} ref={ref}>
      <TableWrapper sticky celled className="aridhia-cohorts-table" columns={columns}>
        <CohortsTableHeader
          category={category}
          cohorts={items}
          columns={columns}
          hideColumns={hideColumns}
          loaderButton={!hideColumns}
          readErrors={readErrors}
          readStatus={readStatus}
        >
          {togglePresentation && (readStatus !== states.PENDING) && (
          <ToggleCardsButton
            display={presentationOptions.TABLE}
            disabled={readStatus === states.PENDING}
            onClick={() => togglePresentation(category, presentationOptions.CARDS)}
          />
          )}
          <CohortsFilters category={category} className="aridhia-table-filter" />
        </CohortsTableHeader>
        <Table.Body>
          <CohortsTableRows
            category={category}
            columns={columns}
            items={items}
            onCheckBoxClick={onCheckBoxClick}
          />
        </Table.Body>
      </TableWrapper>
      <NoRowsWithPagination
        canCreate={canCreate}
        currentPage={pageNumber}
        entity="cohort"
        goToPage={({ page }) => goToCategoryPage(fetchData, category, page, ref)}
        icon="filter"
        items={items}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
        url={codeUrl(urls.COHORT, newCohortCode, '#')}
      />
    </div>
  );
};

export default CohortsTable;
